{
	"type": "line",
	"minzoom": 7,
	"layout": { "line-cap": "round", "line-join": "round" },
	"paint": {
		"line-color": [
			"match",
			["get", "status"],
			"Open",
			"#2f6fd1",
			"Assessed",
			"#2f9e44",
			"Finalized",
			"#7a7f85",
			"#999999"
		],
		"line-width": ["interpolate", ["linear"], ["zoom"], 9, 4, 18, 22],
		"line-opacity": 0.45
	}
}
